// Holds the live MediaStream received from a paired phone camera, so the app's
// camera consumers (Execute, /vision, Inputs preview) can use it in place of a
// local getUserMedia stream. The raw phone stream is normalised (rotated to the
// chosen orientation + shaped to the chosen ratio) by mobileView; consumers get
// that normalised stream. A module-level singleton with subscribe.
import { buildMobileView, getMobileView, destroyMobileView } from './mobileView'

let raw = null
const subscribers = new Set()

export function setMobileStream(next) {
    raw = next || null
    if (raw) buildMobileView(raw)
    else destroyMobileView()
    const out = getMobileStream()
    subscribers.forEach((fn) => {
        try {
            fn(out)
        } catch (e) {
            /* ignore */
        }
    })
}

// The stream consumers use: the normalised (rotated/ratio'd) view, or the raw
// stream if the view isn't ready yet.
export function getMobileStream() {
    return getMobileView() || raw
}

export function hasMobileStream() {
    return !!raw && raw.getVideoTracks().some((t) => t.readyState === 'live')
}

// Drop the reference (does not stop the raw remote tracks — the peer owns them).
export function clearMobileStream() {
    setMobileStream(null)
}

export function onMobileStream(fn) {
    subscribers.add(fn)
    return () => subscribers.delete(fn)
}
